/*=========================================================================================
  File Name: state.js
  Namespace: users
  Description: Vuex Store - User state
==========================================================================================*/


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

export const stateBuilder = () => {
  return {
    token: null,
    id: null,
    username: null,
    customer_id: null,
    email: null,
    links: {
      rel: '',
      uri: ''
    },
    content_api_id: '',
    team_ids: [],
    account_id: '',
    roles: {
      data: []
    },
    tokens: {
      data: {
        Bearer: null,
        Refresh: null
      }
    },
    profile: {
      data: {
        first_name: '',
        last_name: '',
        avatar: ''
      }
    }
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentUser: stateBuilder()
}

export default state
